import {
  type HttpInterceptorFn,
  type HttpHandlerFn,
  type HttpRequest,
} from '@angular/common/http';
import {inject} from '@angular/core';
import {LoadingService} from '@/app/core/services/loading.service';
import {SKIP_GLOBAL_LOADING} from '@/app/core/interceptors/skip-loading.context';
import {environment} from '@/environments/environment';
import {finalize} from 'rxjs';

function isApiRequest(url: string): boolean {
  if (url.startsWith(environment.baseUrl)) return true;
  if (url.startsWith('/api/')) return true;
  try {
    const parsed = new URL(
      url,
      typeof window !== 'undefined'
        ? window.location.origin
        : 'http://localhost',
    );
    return parsed.pathname.startsWith('/api/');
  } catch {
    return false;
  }
}

export const loadingInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const loading = inject(LoadingService);
  const isApi = isApiRequest(req.url);
  const skipLoading = req.context.get(SKIP_GLOBAL_LOADING);
  if (isApi && !skipLoading) {
    loading.addRequest();
  }

  return next(req).pipe(
    finalize(() => {
      if (isApi && !skipLoading) {
        loading.removeRequest();
      }
    }),
  );
};
